import React, { useContext } from 'react';
import { DataContext } from '../../data/DataContext';
import { IconOk, IconError } from '../../images'

const Step4 = () => {

    const { CoopenaeAuto } = useContext(DataContext);

    return (
        <div className="step-ca">
            <div className="step-container-ca">
                <div className="mt-10">
                    <span className="sub-title-ca">
                        {CoopenaeAuto.isSaved && '¡Cotización exitosa!'}
                        {!CoopenaeAuto.isSaved && '¡Oops! Ocurrió un error'}
                    </span>
                </div>
                <div className="mt-5 mb-30">
                    <span className="sub-title2-ca">
                        {CoopenaeAuto.isSaved && 'Muchas gracias por confiar en COOPENAE Seguros y  Seguros LAFISE, la aseguradora digital regional.'}
                        {!CoopenaeAuto.isSaved && 'Pero no te preocupes hemos recibido tus datos relacionados la cotización del seguro'}
                    </span>
                </div>
                <div>
                    <div className="container-finish-ca">

                        {CoopenaeAuto.isSaved && <div className="lbl-finish ">  <span >Tú número de solicitud es: <span className="lbl-number">{CoopenaeAuto.requestNumber}</span> </span> </div> }
                        <div className="container-icon-finish-ca">
                            {CoopenaeAuto.isSaved && <IconOk classNameIcon="iconFinish-ca" />}
                            {!CoopenaeAuto.isSaved && <IconError classNameIcon="iconFinish-ca" />}
                        </div>
                        <div className="lbl-finish2">
                            {CoopenaeAuto.isSaved && <span>En breve recibirás en tu correo electrónico una copia de tu oferta de seguro de automóvil.</span>}
                            {!CoopenaeAuto.isSaved && <span>En breve,nuestros ejecutivos de COOPENAE Seguros te contactarán para confirmar la compra de tu póliza</span>}
                        </div>
                        <div className="lbl-finish2">
                            {CoopenaeAuto.isSaved && <span>Así mismo, nuestros ejecutivos de COOPENAE Seguros te contactarán para confirmar la compra de tu póliza</span>}
                            {!CoopenaeAuto.isSaved && <span>Recuerda tener a mano la tarjeta de crédito o débito con la que confirmarás la compra de tu póliza de automóvil</span>}
                        </div>
                        <div className="container-icon-finish-ca">
                            <button type="button" className="control-button-btn-ca next-ca" onClick={() => window.location.reload()}>Terminar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Step4;